import { render, staticRenderFns } from "./kxResource.vue?vue&type=template&id=65e000eb&scoped=true&"
import script from "./kxResource.vue?vue&type=script&lang=js&"
export * from "./kxResource.vue?vue&type=script&lang=js&"
import style0 from "./kxResource.vue?vue&type=style&index=0&id=65e000eb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e000eb",
  null
  
)

export default component.exports